import { render } from "./serviceComponent.vue?vue&type=template&id=69e88c8e"
import script from "./serviceComponent.vue?vue&type=script&lang=js"
export * from "./serviceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__